<template>
  <div
    class="validate-session card"
  >
    <div v-if="showProgress" class="progress">
      <div class="validate-session__header">
        <div class="left">
          <span class="section-title">Progress</span>
        </div>
      </div>
      <div class="body _separator">
        <TaskStatusBars :task="session.docker_task" />
      </div>
    </div>
    <div class="statistics">
      <div class="validate-session__header">
        <div class="left">
          <input
            type="checkbox"
            :checked="isSelected"
            @change="toggleSelection()"
            @click.stop
            v-tooltip="`Select session`"
            style="margin: 0; cursor: pointer; width: 18px; height: 18px; flex-shrink: 0;"
          />
          <span class="section-title">{{ manageType() }}</span>
        </div>
        <div class="right">
          <div class="icon-container">
            <IconButton
              v-tooltip="`Refresh validate session`"
              class="icon refresh-icon"
              :icon="'refresh'"
              :width="20"
              :height="20"
              :type="'click'"
              @click.stop="handleRefresh()"
            />
            <!-- <IconButton
              v-tooltip="`View detailed information for validate session`"
              class="icon maximize-icon"
              :icon="'maximize'"
              :width="20"
              :height="20"
              :type="'click'"
              @click.stop="handleSessionInfoClick(session)"
            /> -->
            <IconButton
              v-tooltip="`View charts for validate session`"
              class="icon analytics-icon"
              :icon="'analytics'"
              :width="22"
              :height="22"
              :type="'click'"
              @click.stop="handleShowChartsClick()"
            />
            <IconButton
              v-if="permissions && permissions.trainer_write"
              v-tooltip="`Terminate validate session. This will stop the session, but you can still view validation artifacts`"
              class="icon stop-icon"
              :icon="'stop_circle'"
              :width="22"
              :height="22"
              :type="'click'"
              @click.stop="terminateTask(session)"
            />
          </div>
        </div>
      </div>
      <div class="body scrollbar" @click.stop="handleSessionInfoClick(session)">
        <div class="body__header">
          <div class="owner-id-display">
            <UserIcon
              :user="userList?.find((e) => e.username === session.docker_task.username)"
              :size="'32px'"
            />
            <EncodedIdField
              :id="session.id"
              :type="'validator'"
              :hideLabel="false"
            />
            <div val-status class="status-col">
              <span v-if="sessionStatus?.toLowerCase().includes('complete')" class="status-tag _complete"><div class="status-icon">&#x2713;</div>Complete</span>
              <span v-else-if="sessionStatus?.toLowerCase().includes('error')" class="status-tag _error"><div class="status-icon">&#x2716;</div>Error</span>
              <span v-else-if="sessionStatus?.toLowerCase().includes('terminate')" class="status-tag _warning"><div class="status-icon">&#x21;</div>Terminated</span>
              <span v-else-if="sessionStatus" class="status-tag _running"><div class="running-icon" />
                {{ String(sessionStatus).charAt(0).toUpperCase() + String(sessionStatus).slice(1) }}
              </span>
            </div>
          </div>
          <div class="name-display">
            <div
              v-tooltip="session.docker_task && session.docker_task.name ? session.docker_task.name : 'Unknown'"
              class="description"
            >
              {{ session.docker_task && session.docker_task.name ? session.docker_task.name : "Unknown" }}
            </div>
          </div>
        </div>
        <hr>
        <div class="body__grid scrollbar" v-tooltip:top="'Click to view details'" >
          <div class="statistics-field">
            <div class="description">Start Date</div>
            <div class="value"><span v-if="session.docker_task">{{ formatTime(session.docker_task.date) }}</span></div>
          </div>
          <div class="statistics-field">
            <div class="description">Duration</div>
            <div class="value"><span v-if="session.docker_task && getEndTime(session.docker_task)" class="duration">{{ getEndTime(session.docker_task) }}</span></div>
          </div>
          <div v-if="trainingSession" class="statistics-field">
            <div class="description">Training Session</div>
            <div class="value hyperlink" @click="navigateToTrainingSession(trainingSession.id)">{{ `(t-${Number(trainingSession.id).toString(16)})` }} {{ trainingSession.name }}</div>
          </div>
          <div v-if="session.params.validate_params" class="statistics-field">
            <div class="description">Model</div>
            <div class="value">{{ session.params.validate_params.model }}</div>
          </div>
        </div>
          <DescriptionField
            :text="session.description"
            :clickable="true"
            :data="session"
            @click="handleEditSessionClick"
          />
      
      </div>
    </div>
  </div>
</template>
<script>
import IconButton from '@/components/IconButton.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import EncodedIdField from '@/components/EncodedIdField.vue';
import TaskStatusBars from '@/components/TaskStatusBars.vue';
import UserIcon from '@/components/UserIcon.vue';
import DescriptionField from '@/components/utils/DescriptionField.vue';

export default {
  name: "ValidatorCard",
  components: {
    IconButton,
    EncodedIdField,
    TaskStatusBars,
    UserIcon,
    DescriptionField,
  },
  props: {
    session: {
      type: Object,
      default: () => {},
    },
    permissions: {
      type: Object,
      default: () => {},
    },
    trainingSessions: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['info-clicked', 'delete-session', 'refresh-session', 'show-charts', 'select-session', 'terminate-session', 'session-selected', 'edit-session'],
  data() {
    return {
      dsConn: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      show_menu: false,
      hideProgress: false,
      sessionStatus: "",
      isSelected: false,
    };
  },
  computed: {
    showProgress() {
      const dt = this.session.docker_task;
      if (dt.status?.toLowerCase().includes('complete')) return false;
      if (dt.data.length < 4) return false;
      return true;
    },
    userList() {
      return this.$store.state.user.userList;
    },
    trainingSession() {
      if (this.trainingSessions && this.trainingSessions.length > 0) {
        if (this.session.training_session_id) {
          const trainSession = this.trainingSessions.find((e) => e.id === this.session.training_session_id);
          return trainSession;
        } else if (this.session.validate_params.train_session_id) {
          const trainSession = this.trainingSessions.find((e) => e.id === this.session.validate_params.train_session_id);
          return trainSession;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
  },
  watch: {
    session: {
      deep: true,
      handler() {
        if (this.session) {
          this.getStatus(this.session);
        }
      },
    },
    selected(newVal) {
      this.isSelected = newVal;
    },
  },
  mounted() {
    if (this.session) {
      this.getStatus(this.session);
    }
  },
  methods: {
    handleEditSessionClick() {
      this.$emit('edit-session', this.session);
    },
    manageType() {
      if (!this.session) return "-";
      const type = this.session.docker_task.manage_type;
      if (type == '') return "Cloud";
      if (type == 'aws') return "Cloud";
      if (type == 'user') return "User Managed";
      if (type == 'kubernetes') return "Kubernetes";
      return "--";
    },
    toggleHide(v) {
      this.hideProgress = v;
    },
    handleSessionInfoClick() {
      this.$emit('info-clicked');
    },
    getStatus(session) {
      this.sessionStatus = session.docker_task.status;
    },
    getEndTime(docker_task) {
      if (docker_task.end_date !== "0001-01-01T00:00:00Z" && docker_task.date !== "0001-01-01T00:00:00Z") {
        const msDiff = new Date(docker_task.end_date) - new Date(docker_task.date);
        const minutes = Math.floor(msDiff / (1000 * 60)) % 60;
        const hours = Math.floor(msDiff / (1000 * 60 * 60)) % 24;
        const days = Math.floor(msDiff / (1000 * 60 * 60 * 24));
        const result = [];
        if (days > 0) result.push(`${days} day${days > 1 ? 's' : ''}`);
        if (hours > 0) result.push(`${hours} hr${hours > 1 ? 's' : ''}`);
        if (minutes > 0) result.push(`${minutes} min${minutes > 1 ? 's' : ''}`);
        return result.join(" ") || "0 mins";
      } else if (docker_task.end_date === "0001-01-01T00:00:00Z" && docker_task.date !== "0001-01-01T00:00:00Z") {
        const msDiff = Date.now() - new Date(docker_task.date);
        const minutes = Math.floor(msDiff / (1000 * 60)) % 60;
        const hours = Math.floor(msDiff / (1000 * 60 * 60)) % 24;
        const days = Math.floor(msDiff / (1000 * 60 * 60 * 24));
        const result = [];
        if (days > 0) result.push(`${days} day${days > 1 ? 's' : ''}`);
        if (hours > 0) result.push(`${hours} hr${hours > 1 ? 's' : ''}`);
        if (minutes > 0) result.push(`${minutes} min${minutes > 1 ? 's' : ''}`);
        return result.join(" ") || "0 mins";
      } else {
        return null;
      }
    },
    formatTime(str) {
      return `${new Date(str).toLocaleTimeString('default', {
        year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,
      })}`;
    },
    toggleSelection() {
      this.isSelected = !this.isSelected;
      this.$emit('session-selected', {
        sessionId: this.session.id,
        isSelected: this.isSelected,
      });
    },
    handleRefresh() {
      this.$emit('refresh-session', this.session);
    },
    handleShowChartsClick() {
      this.$emit('show-charts', this.session);
    },
    terminateTask(session) {
      this.$emit('terminate-session', session);
    },
    navigateToTrainingSession(id) {
      this.$router.push({ name: 'experiment.training.details', query: { train_session_id: id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  position: relative;
  height: fit-content;
  padding: 16px;
  margin: 0;
  text-align: left;
  border-radius: 8px;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);

}

.validate-session {
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  height: 320px;
  padding: 0;
  cursor: pointer;
  

  &__header {
    display: flex;
    flex-direction: row;
    padding: 4px 16px;
    background: var(--gray-200);
    height: 32px;
  }

  .progress {
    display: flex;
    flex-direction: column;
    height: 100%;
    //width: 40%;
    width: 350px;
  }
  .statistics {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 350px;
  }

  .left {
      width: 50%;
      min-width: 50%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
    }

  .right {
    width: 50%;
    min-width: 50%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end
  }
}

.section-title {
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 1rem;
  font-weight: 700;
  color: var(--body-text-color-heading);
  letter-spacing: 0.025em;
  gap: 6px;
}

.item-selector{
  width: fit-content;
  height: fit-content;
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 100%;
}

.body {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  padding: 10px;
  overflow: auto;
  cursor: pointer;

  &__header{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    .owner-id-display {
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: center;
      width: 100%;

      .labels-container {
        flex: 1
      }
    }

    .name-display {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start
    }

    .description {
      font-size: 0.9rem;
      font-weight: 600;
      color: var(--body-text-color);
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &__grid-field {
    display: block;
    max-width: 300px;
  }

  &__grid-field + &__grid-field {
    margin-top: 10px;
  }

  &__grid {
    display: block;

    .statistics-field {
      display: flex;
      flex-direction: row;
      gap: 10px;
      margin-top: 1px;
    }

    .description {
      font-size: 0.9rem;
      font-weight: 600;
      color: var(--body-text-color);
      width: 120px;
      min-width: 120px;
    }
    .value {
      font-size: 0.9rem;
      font-weight: 600;
      color: var(--body-text-color-secondary);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  &__description {
    flex: 1;
    white-space: normal;
    font-style: italic;
    color: #5a7a94;
    font-size: 11px;
    line-height: 1.4;
    border-top: 1px solid #d0d0d0;
    margin-top: 4px;
    padding-top: 4px;
  }

  &._separator::after {
    content: "";
    position: absolute;
    right: 0;
    top: 5%;
    bottom: 5%;
    width: 1px;
    background-color: #9a9ca2;
  }
}

.icon-container {
  display: flex;
  align-items: center;
  margin-left: 10px;
  @include themify() {
    color: themed('body-text-color-secondary');
  }
  .icon + .icon {
    margin-left: 14px;
  }
}

.footer {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
}

.icon {
  @include themify() {
    color: themed('body-text-color-secondary');
  }
}

.icon:hover {
  @include themify() {
    color: themed('color-primary');
    background: themed('icon-hover-color');
    border-radius: 100%;
    box-shadow: 0 0 0 4px themed('icon-hover-color');
  }
}

.icon.delete:hover {
  color: var(--color-error)
}

.status-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  min-width: 100px;
  border-radius: 18px;
  padding: 4px 6px;
  line-height: 1;
  font-size: 0.625rem;
  font-weight: 700;
  white-space: nowrap;
  border: 2px solid;
  box-shadow: 0px 0px 1px rgb(0 0 0 / 25%), 0px 1px 4px rgb(0 0 0 / 25%);
  @include themify() {
    color: themed('color-black');
  }

  &._complete {
    @include themify() {
      color: themed('color-status-complete');
      background: themed('color-status-complete-background');
    }
  }
  &._running {
    @include themify() {
      color: themed('color-status-running');
      background: themed('color-status-running-background');
    }
  }
  &._error {
    @include themify() {
      color: themed('color-status-error');
      background: themed('color-status-error-background');
    }
  }

  &._warning {
    @include themify() {
      color: themed('color-status-warning');
      background: themed('color-status-warning-background');
    }
  }

  .running-icon {
    color: inherit;
    width: 4px;
    height: 4px;
    border: solid 4px;
    border-radius: 4px;
    margin-right: 4px;
  }

  .status-icon {
    color: inherit;
    margin-right: 4px;
  }
}

.session-id-field {
  margin-right: 20px;
}

:deep() {
  .v-expansion-panel__shadow {
    box-shadow: none !important;
  }
}

.validate-sessions-empty {
  display: flex;
  flex-direction: column;
  height: 150px;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: bold;
  border: solid 1px black;
  border-radius: 8px;
  @include themify() {
    background: radial-gradient(circle, rgba($color-primary-300, 0.075) 50%, rgba(var(--color-primary-rgb), 0.125) 100%);
  }

  span {
    padding: 16px;
    text-align: center;
  }
}

.select-checkbox{
  position: relative !important;
  top: -7px;
  left: -5px;
}

</style>
